import { Container, Row, Col } from "reactstrap";
import {
    ArrowForward,
    OpenInNew,
    ViewInAr
} from "@mui/icons-material";

import "./CAD_Available_Courses.css";


const defaultCourses = [
    {
        name: "NX Customization",
        url: "/nx-open-customization-automation-training",
        icon: "NX"
    },
    {
        name: "SolidWorks API",
        url: "/solidworks-api-customization-automation-training",
        icon: "SW"
    },
    {
        name: "CATIA CAA",
        url: "/catia-caa-customization-automation-training",
        icon: "CA"
    },
    {
        name: "Creo Toolkit",
        url: "/creo-toolkit-customization-training",
        icon: "CR"
    },
    {
        name: "Revit API",
        url: "/autodesk-revit-api-customization-automation-course",
        icon: "RV"
    },
    {
        name: "AutoCAD API",
        url: "/autocad-api-customization-automation-online-courses",
        icon: "AC"
    },
    {
        name: "Teamcenter",
        url: "/teamcenter-plm-customization-training-itk-rac-soa-awc",
        icon: "TC"
    },
    {
        name: "Inventor API",
        url: "/autodesk-inventor-api-customization-automation-course",
        icon: "IN"
    },
    {
        name: "Windchill",
        url: "/ptc-windchill-plm-customization-course",
        icon: "WC"
    },
    {
        name: "Solid Edge API",
        url: "#",
        icon: "SE"
    }
];


function CADAvailableCourses({
    title = "Available Courses",

    subtitle =
        "Explore our CAD customization, automation, and PLM courses.",

    courses = defaultCourses
}) {

    return (

        <section className="cad-available-courses">

            <Container>

                {/* =================================================
                    SECTION HEADER
                ================================================== */}

                <div className="cad-courses-header text-center">

                    <span className="cad-courses-badge">

                        <ViewInAr fontSize="small" />

                        CAD & PLM COURSES

                    </span>


                    <h2>
                        {title}
                    </h2>


                    <p>
                        {subtitle}
                    </p>


                    <div className="cad-courses-divider">

                        <span></span>

                    </div>

                </div>


                {/* =================================================
                    COURSES
                ================================================== */}

                <Row className="g-4">

                    {courses.map((course, index) => (

                        <Col
                            key={course.url !== "#" ? course.url : index}
                            xs="12"
                            sm="6"
                            lg="4"
                            xl="3"
                        >

                            {course.url === "#" ? (

                                /* =================================================
                                   COURSE WITHOUT ROUTE
                                ================================================== */

                                <div
                                    className="cad-course-card cad-course-disabled"
                                >

                                    <div className="cad-course-icon">
                                        {course.icon}
                                    </div>


                                    <div className="cad-course-content">

                                        <span className="cad-course-number">
                                            {String(index + 1).padStart(2, "0")}
                                        </span>


                                        <h3>
                                            {course.name}
                                        </h3>


                                        <span className="cad-course-link">
                                            Coming Soon
                                        </span>

                                    </div>


                                    <OpenInNew
                                        className="cad-course-external-icon"
                                        fontSize="small"
                                    />

                                </div>

                            ) : (

                                /* =================================================
                                   INTERNAL REACT ROUTE
                                ================================================== */

                                <a
                                    href={course.url}
                                    className="cad-course-card"
                                >

                                    <div className="cad-course-icon">
                                        {course.icon}
                                    </div>


                                    <div className="cad-course-content">

                                        <span className="cad-course-number">
                                            {String(index + 1).padStart(2, "0")}
                                        </span>


                                        <h3>
                                            {course.name}
                                        </h3>


                                        <span className="cad-course-link">

                                            Explore Course

                                            <ArrowForward fontSize="small" />

                                        </span>

                                    </div>


                                    <OpenInNew
                                        className="cad-course-external-icon"
                                        fontSize="small"
                                    />

                                </a>

                            )}

                        </Col>

                    ))}

                </Row>

            </Container>

        </section>
    );
}


export default CADAvailableCourses;